<template>
  <div class="detail-list">
    <template
      v-if="room"
    >
      <h3 class="details-list-header">Details<br>zu diesem<br>Raum</h3>
      <div
        v-for="(detail, index) in room.details"
        :key="index"
        class="video-button tilillium text-center"
        :id="`button-${index + 1}`"
        @click="playDetailVideo(detail)"
        style="cursor: pointer;"
      >

        <b-img
          :src="detail.icon.url"
          :alt="`Vorschaubild zum Detail ${detail.title}`"
          fluid
          class="detail-icon"
        />
        <h4>{{ detail.title }}</h4>
      </div>
      <div 
        class="video-button tilillium text-center panorama-button"
        @click="navTo(`/panorama/${room.orderNumber}`)"
        v-if="$route.name === 'rundgang'"
      >
        Großansicht<br>Panorama
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'detail-list',
  props: {
    current: String
  },
  data () {
    return {
        active: true
    }
  },
  methods: {
    ...mapActions({
      
    }),
    navTo(target) {
      this.$router.push(target)
    },
    playDetailVideo(detail) {
      const r = this.room.orderNumber
      this.$store.dispatch('selectDetailVideo', detail)
      this.$router.push(`/raumdetail/${r}`)
    },
    markVideo() {
    //   this.setMarkedVideo(nr)
    },
    markVideoButton() {
    //   const videoId = this.selected ? `#button-${this.selected.orderNumber}` : null
    //   document.querySelectorAll('.video-button').forEach(b => {
    //     b.classList.remove('selected')
    //   })
    //   const selectedButton = document.querySelector(videoId)
    //   if (selectedButton) selectedButton.classList.add('selected')
    }
  },
  computed: {
      ...mapGetters({
          selected: 'getSelectedRoom',
          rooms: 'getRoomsData'
      }),
      room () {
      let room = {}
        if (this.selected) {
         room = this.rooms.find(r => r.orderNumber === this.selected.orderNumber)
        } else {
          room = this.rooms.find(r => r.orderNumber === this.$route.params.id)
        }
      return room
      } 
  },
  watch: {
    selected: function () {
      this.markVideoButton()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '@/scss/custom.scss';
  .detail-list {
    max-width: 8rem;
    // min-height: calc(100vh - 6rem);
    padding: 1.8rem 0;
    background-color: $sand-dark-65;
    @media (max-width: $tabletL) {
      max-width: none;
      padding: 0;
    }
  }
  .panorama-button {
    padding: 2rem 0;
  }
  .video-button {
    border-bottom: 1px solid $grey-light-50;
    &:hover,
    &.selected {
      background-color: $red-dark;
      color: $sand-light;
    }
    @media (max-width: $tabletL) {
      display: inline-block;
      max-width: 25%;
      padding-top: 0;
      padding-bottom: 0;
      border-bottom: none;
      padding-left: 1rem;
      padding-right: 1rem;
      margin-right: 1rem;
    }
  }
  .video-icon {
    display: block;
    padding: 0 1.2rem 0 1.2rem;
  }
  h4 {
    font-size: 1rem;
    margin-bottom: 0;
    padding: .2rem 0 1rem 0;
  }
  h3.details-list-header {
    font-size: 1rem;
    border-bottom: 1px solid $grey-light-50;
    padding: 0 1rem .8rem 1rem;
    color: $red-dark;
    @media (max-width: $tabletL) {
      display: inline-block;
      padding-top: .4rem;
      padding-bottom: 0;
      border-bottom: none;
    }
  }
</style>
